
/**
 * 快判任务 judge api
 */
import { http, https } from '../../global/axios';
import { PAGINATION_PARAM } from '../../global/constants';

/**
 * 快判任务 列表
 */
export const list = (params) => {
  return http.post(`v1/judge/task/rows.json`, params);
};
/**
 * 快判任务 详情
 */
export const detail = (params) => {
  return https.post(`v1/judge/task/data.json`, params);
};
/**
 * 任务详情-帮助文档
 */
export const helps = (params) => {
  return http.post(`v1/judge/study/data.json?gid=${params.gid}`, params);
};
/**
 * 获取考核数据
 */
export const getCheckLib = (params) => {
  return http.post(`v1/judge/study/q.json?tid=${params.tid}`, params);
};
/**
 * 考核提交
 */
export const answerCheckLibs = (params) => {
  return https.post(`v1/judge/study/as.json`, params);
};
/**
 * 任务验证
 */
export const validate = (params) => {
  return https.post(`v1/judge/task/validate.json?id=${params.id}`, params);
};
/**
 * 快判获取题目数据
 */
export const getLib = (params) => {
  return http.post(`v1/judge/task/q.json?id=${params.tid}`, params);
};
/**
 * 做题提交
 */
export const answerLib = (params) => {
  return https.post(`v1/judge/task/a.json?id=${params.id}`, params);
};

// export const skipLib = (params) => {
//   return http.post(`v1/judge/task/skip.json`, params);
// }

export const logs = (params) => {
  return http.post(`v1/judge/task/logs.json`, params);
};

